import React from "react";
import { Image, Flex, Spacer, Text, Stack, HStack } from "@chakra-ui/react";
import { useIsAuthenticated } from "@azure/msal-react";
import { useTranslation } from "react-i18next";
import { SignInOutButton } from "./SignInOutButton";
import { useB2CEmail, useB2CUserName } from "../hooks/useB2CAuth";

import logo from "../resources/Moneris_Logo_BIL_White.png";
import LanguageSwitcher from "./LanguageSelector";

const Header = () => {
  const { t } = useTranslation("common");
  const isAuthenticated = useIsAuthenticated();
  
  const { email } = useB2CEmail();
  const userName = useB2CUserName();

  return (
    <Flex px={10} py={4} backgroundColor="brand.darkblue">
      <Image
        htmlWidth="143px"
        htmlHeight="48px"
        src={logo}
        alt={t("Moneris")}
      />      
      <Spacer />
       <HStack>
      {isAuthenticated ? (
        <HStack>
          <Stack spacing="0" pr="4">
            <Text color="white">{userName}</Text>
            <Text color="white" fontSize="sm">
              {email}
            </Text>
          </Stack>
          <SignInOutButton isSignIn={false} />
        </HStack>
      ) : (
        <SignInOutButton isSignIn={true} />
      )}

      <LanguageSwitcher />
      </HStack>
    </Flex>
  );
};

export default Header;
